import moment from 'moment/moment';

// this function formats object for sending on server. Changes empty string value to null and formats dates.
export function modifyObject (obj) {
  for (let key in obj) {
    if (obj[key] === '' || obj[key] === 0) {
      obj[key] = null;
    }
    if (key === 'start_date' || key === 'end_date') {
      obj[key] = moment.utc(obj[key]).format();
    }
  }
  return obj;
}



// WEBPACK FOOTER //
// ./src/helpers/modifyObject.js